import { render, staticRenderFns } from "./PrizeReceiveSet.vue?vue&type=template&id=3f3469cd&"
import script from "./PrizeReceiveSet.vue?vue&type=script&lang=js&"
export * from "./PrizeReceiveSet.vue?vue&type=script&lang=js&"
import style0 from "./PrizeReceiveSet.vue?vue&type=style&index=0&id=3f3469cd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports